export default "__VITE_ASSET__C3MfqXyS__"